import { render, staticRenderFns } from "./BcStatusPill.vue?vue&type=template&id=4fe9d0a6&scoped=true"
import script from "./BcStatusPill.vue?vue&type=script&lang=js"
export * from "./BcStatusPill.vue?vue&type=script&lang=js"
import style0 from "./BcStatusPill.vue?vue&type=style&index=0&id=4fe9d0a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe9d0a6",
  null
  
)

export default component.exports